"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineEERDisplayMode = exports.VARIABLE_SPEED_GRACE_SECONDS = void 0;
/** Grace period for variable speed compressors (seconds) */
exports.VARIABLE_SPEED_GRACE_SECONDS = 300; // 5 minutes
function determineEERDisplayMode(lastMinuteSeerRating, options) {
    const airHandlerAmperage = lastMinuteSeerRating?.airHandlerAvgAmperage ?? 0;
    const condenserAmperage = lastMinuteSeerRating?.condenserAvgAmperage ?? 0;
    const airHandlerDataPoints = lastMinuteSeerRating?.airHandlerDataPoints ?? 0;
    const condenserDataPoints = lastMinuteSeerRating?.condenserDataPoints ?? 0;
    const hasAirHandlerData = airHandlerDataPoints > 0;
    const hasCondenserData = condenserDataPoints > 0;
    const hasAmperageData = hasAirHandlerData || hasCondenserData;
    const isAirHandlerOn = airHandlerAmperage > 0;
    const isCondenserOn = condenserAmperage > 0;
    let mode;
    if (!hasAmperageData || (!isAirHandlerOn && !isCondenserOn)) {
        // No CT data at all, or both are at 0 amperage → system is off
        mode = 'off';
    }
    else if (((!hasAirHandlerData || !isAirHandlerOn) && isCondenserOn) ||
        ((!hasCondenserData || !isCondenserOn) && isAirHandlerOn)) {
        mode = 'peak';
    }
    else {
        mode = 'instant';
    }
    // Variable speed grace period: when condenser is on but within grace period
    if (mode === 'instant' &&
        options?.isVariableSpeed &&
        isCondenserOn &&
        options?.currentRunningPeriodStart) {
        const now = options.now ?? Math.floor(Date.now() / 1000);
        const runningSeconds = now - options.currentRunningPeriodStart;
        if (runningSeconds < exports.VARIABLE_SPEED_GRACE_SECONDS) {
            mode = 'grace';
        }
    }
    return {
        mode,
        airHandlerAmperage,
        condenserAmperage,
        hasAmperageData,
    };
}
exports.determineEERDisplayMode = determineEERDisplayMode;
